/* eslint-disable import/no-named-as-default-member */
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import {chinese, english} from './translations'

i18next
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: english.translation
      },
      cn: {
        translation: chinese.translation
      }
    },
    lng: 'en', 
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    react: {
      wait: false,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'span']
    }
  });

export default i18next